import { combineReducers } from "redux";
import session from "./session";
import navigation from "./navigation";

export default combineReducers({ session, navigation });
